module.exports = __webpack_public_path__ + "static/media/12UNCTAD9.26d63e70.jpg";